export const NOTIFICATION_TYPE = {
  ALL: "ALL",
  TRANSACTION: "TRANSACTION",
  KEYWORD: "KEYWORD",
  TOKEN: "TOKEN",
  APPROVAL: "APPROVAL",
};

export const NOTIFICATION_TOPIC = {
  ALL: "ALL",
  TRACKED_TXS: "TRACKED_TXS",
  KEYWORDS: "KEYWORDS",
  CONFIRMED_TOKENS: "CONFIRMED_TOKENS",
  PENDING_TOKENS: "PENDING_TOKENS",
  VERIFIED_TOKENS: "VERIFIED_TOKENS",
  TOKEN_SOCIALS: "TOKEN_SOCIALS",
  APPROVALS: "APPROVALS",
  STD_TOKENS: "STD_TOKENS",
  DEV_TOKENS: "DEV_TOKENS",
  LIQ_TOKENS: "LIQ_TOKENS",
};

export const NOTIFICATION_STATUS = {
  UNREAD: "UNREAD",
  READ: "READ",
};
